import { Grid } from "react-loader-spinner";

const Loading = ({ type }) => {
  return (
    <div className="global-loader">
      <div className="child-loader">
        <img
          src="/images/skorDefaultLoader.gif"
          className="defaultSkorLoader"
          height="80"
          width="80"
          alt="skor-loading"
        />
      </div>
    </div>
  );
};

export default Loading;
